import sumsubLogo from '@/assets/kyc/sumsub-logo.png';
import { AppLogo } from '@/components/icons/AppLogo';
import { PopupShell } from '@/components/features/Notifications/popups/PopupShell';

export interface KycPreFlowPanelProps {
  /** Backdrop / Escape dismiss — declines verification, closes the gate. */
  onClose: () => void;
  /** "Continue" tap — the only thing that mints a token and launches the Sumsub SDK. */
  onContinue: () => void;
}

/**
 * "Quick Verification" consent step, shown before the Sumsub SDK ever loads —
 * for NOT_STARTED and not-yet-submitted PENDING flows. The SDK previously
 * launched immediately on gate-open; it now launches only after this explicit
 * "Continue" tap. Reuses the ARC-111 pop-up shell for the card chrome; the
 * body content mirrors Sumsub's own consent screen (logo, Sumsub mark, legal
 * disclaimer) per the Figma spec.
 */
export function KycPreFlowPanel({ onClose, onContinue }: KycPreFlowPanelProps) {
  return (
    <PopupShell open onClose={onClose} testId="kyc-preflow-panel">
      <AppLogo disableAnimation />
      <div className="flex flex-col items-center gap-3">
        <h2 className="text-3xl font-semibold tracking-[-0.6px] text-ink">Quick Verification</h2>
        <p className="text-xl leading-[30px] text-ink">Get verified to start trading!</p>
      </div>
      <img src={sumsubLogo} alt="Sumsub" className="h-11 w-auto object-contain" />
      <div className="flex flex-col items-center gap-3">
        <h3 className="text-2xl font-semibold text-ink">Crown Prediction verification</h3>
        <p className="max-w-[394px] text-base leading-[22px] text-muted">
          You&apos;re about to submit sensitive data to Crown Prediction. If you received this link from a suspicious source,
          please close this page and notify us immediately.
        </p>
      </div>
      <button
        type="button"
        onClick={onContinue}
        data-testid="kyc-preflow-continue"
        className="h-12 w-full rounded-full bg-[#1a1a1a] font-sans text-xl font-semibold text-white transition-opacity hover:opacity-90 active:opacity-80"
      >
        Continue
      </button>
    </PopupShell>
  );
}
